import React, { Component } from 'react';
import { connect } from 'react-redux';
import SearchSelectMenu from '../../UI/SearchSelectMenu/SearchSelectMenu';
import NetBankingOptions from './NetBankingOptions/NetBankingOptions';
import Button from '../../UI/Button/Button';

import { setBankOptions, setAmountDetails } from '../../../store/actions/index';

class NetBanking extends Component {

    state = {
        isdSelectActive: false,
        value: null,
        displayText: 'Select Your Bank',
        selectedOption: {
            value: "",
            label: "Select Your Bank"
        }
    }

    handleChange = (selectedOption) => {
        const nbPayment = this.props.netBankingPayment;
        let bankCharge = null;
        Object.entries(nbPayment).forEach(entry => {
            let key = entry[0];
            let value = entry[1];
            if (selectedOption.value === key) {
                bankCharge = value;
            }
        })
        this.setState({ selectedOption: selectedOption });
        this.props.onSetBankOptions(selectedOption.label, selectedOption.value);
        this.props.onSetAmountDetails(bankCharge);
    }

    render() {
        let sortedBanks = this.props.data.banks.sort((a, b) => {
            return parseInt(a.priority, 10) - parseInt(b.priority, 10);
        })
        let selectMenuArray = [];
        for (let i = 0; i < sortedBanks.length; i++) {
            let tempObject = {};
            tempObject.value = sortedBanks[i].code;
            tempObject.label = sortedBanks[i].displayText;
            selectMenuArray.push(tempObject);
        }
        return (
            <React.Fragment>
                <div className={`mb-4`}>
                    <NetBankingOptions banks={this.props.data.preferredBanks} change={this.handleChange} /> 
                </div>
                <div className={`mb-4`}>
                    <div className={`u-flex align-items-center u-relative mr-3 u-height60`}>
                        <SearchSelectMenu 
                            value={this.state.selectedOption}
                            options={selectMenuArray} 
                            onChange={this.handleChange} 
                            placeholder='ISD Code' />
                    </div>
                </div>
                <div className={`u-flex justify-content-between align-items-center mt-auto phone-f-column`}>
                    <div className={`u-phoneWidth100Percent phone-mb-4`}></div>
                    <div className={`u-phone-width100Percent`}> 
                        <Button disabled={this.state.selectedOption.value === ''} onClick={this.props.clicked} theme='Primary' type='Pay'>Pay Now</Button>
                    </div>
                </div>
            </React.Fragment>
        );
    }
} 

const mapStateToProps = state => {
    return {
        netBankingPayment: state.payments.bookingDetails.agentPaymentOptions.amountDetails.NB
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSetBankOptions: (option, code) => dispatch(setBankOptions(option, code)),
        onSetAmountDetails: (val) => dispatch(setAmountDetails(val))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NetBanking);


// WEBPACK FOOTER //
// ./src/components/Payment/NetBanking/NetBanking.js